/**
 * News categories scroll behavior.
 *
 * Detects overflow and toggles the is-overflow class so that
 * justify-content switches from center to flex-start.
 * Scrolls the active / clicked category item to the left edge
 * of the container.
 */

function updateOverflowState(container) {
  const isOverflowing = container.scrollWidth > container.clientWidth;
  container.classList.toggle("is-overflow", isOverflowing);
}

function scrollItemIntoView(item, container) {
  if (!item || !container) return;

  const containerRect = container.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();

  const isOverflowingLeft = itemRect.left < containerRect.left;
  const isOverflowingRight = itemRect.right > containerRect.right;

  // Always scroll active item to the left/start of the container.
  if (!isOverflowingLeft && !isOverflowingRight) return;

  const scrollLeft =
    container.scrollLeft + itemRect.left - containerRect.left;

  container.scrollTo({
    left: scrollLeft,
    behavior: "smooth",
  });
}

function initActiveItem(container) {
  const activeItem = container.querySelector(".cat-item.cat-active");
  if (!activeItem) return;
  scrollItemIntoView(activeItem, container);
}

export function initNewsCategories() {
  const containers = document.querySelectorAll(".news-categories .category");
  if (!containers.length) return;

  containers.forEach((container) => {
    // Detect overflow and toggle class.
    updateOverflowState(container);

    // Scroll active item into view on page load.
    initActiveItem(container);

    // Scroll clicked item into view.
    container.addEventListener("click", (event) => {
      const item = event.target.closest(".cat-item");
      if (!item || !container.contains(item)) return;
      scrollItemIntoView(item, container);
    });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      containers.forEach((container) => {
        updateOverflowState(container);
        initActiveItem(container);
      });
    }, 150);
  });
}
